import {dispatch} from 'redux';
import Resource from '../services/Resource';
import PrivateAPIResource from '../services/PrivateAPIResource';
import * as types from './actionTypes';
import * as certificateActions from './certificateActions';
import * as spinnerActions from './spinnerActions';
import {toastr} from 'react-redux-toastr';

import {toastrErrorHandler} from "./utils";

// actions

export function getCurrentUserSuccess(user) {
    return {type: types.GET_CURRENT_USER_SUCCESS, user};
}

export function getUserProfileSuccess(user) {
    return {type: types.GET_USER_PROFILE_SUCCESS, user}
}

export function getUserSuccess(user) {
    return {type: types.GET_USER_SUCCESS, user};
}

export function loadUsersSuccess(users) {
    return {type: types.LOAD_USERS_SUCCESS, users};
}

export function updateUserRegionId(regionId) {
    return {type: types.UPDATE_USER_PROFILE_REGION_ID, regionId};
}

export function updateUserMunicipalityId(municipalityId) {
    return {type: types.UPDATE_USER_PROFILE_MUNICIPALITY_ID, municipalityId};
}

export function updateUserAddressId(addressId) {
    return {type: types.UPDATE_USER_PROFILE_ADDRESS_ID, addressId};
}

export function preloadUserAddressSuccess(addresses) {
    return {type: types.PRELOAD_USER_PROFILE_ADDRESS_SUCCESS, addresses};
}

export function createUserSuccess(user) {
    return {type: types.CREATE_USER_SUCCESS, user};
}

export function updateUserProfileSuccess(user) {
    return {type: types.UPDATE_USER_PROFILE_SUCCESS, user};
}

export function detachCompanySuccess(userIds) {
    return {type: types.DETACH_COMPANY_SUCCESS, userIds};
}

export function deleteUserSuccess(id) {
    return {type: types.DELETE_USER_SUCCESS, id};
}

export function getDemoAdminUserSuccess(user) {
    return {type: types.GET_DEMO_ADMIN_USER, user};
}

export function getEmptyDemoAdminUserSuccess() {
    return {type: types.GET_DEMO_ADMIN_USER, user: null};
}

export function resetUser() {
    return { type: types.RESET_USER };
}
// action creators

export function getCurrentUser() {
    return function (dispatch) {
        return PrivateAPIResource.get('me').then(user => {
            dispatch(getCurrentUserSuccess(user));
            dispatch(getUserProfile(user));
            // TODO need to fix situation when user hasn't company
            // dispatch(certificateActions.initializeSelectedCertificates(user.company.certificates));
        });
    }
}

function getUserProfile(user) {
    return (dispatch) => {
        dispatch(getUserProfileSuccess(user));
    }
}

export function createUser(params, isFormData = true) {
    return (dispatch) => {
        return PrivateAPIResource.create('users', params, isFormData).then(user => {

        }).catch(toastrErrorHandler);
    };
}

export function updateUserProfile(params, id = null, isFormData = false) {
    return (dispatch) => {
        return PrivateAPIResource.update('user-profiles', params.id, params, isFormData).then(user => {
            dispatch(updateUserProfileSuccess(user));
            dispatch(getCurrentUserSuccess(user));
        }).catch(toastrErrorHandler);
    };
}

export function updateUser(params, id = null) {
    let isCurrentUser = !id;
    id = id || params.id;

    return (dispatch, state) => {
        return PrivateAPIResource.update('users', id, params, true).then(user => {
            if(isCurrentUser) {
                dispatch(updateUserProfileSuccess(user));
                dispatch(getCurrentUserSuccess(user));
            }
        }).catch(toastrErrorHandler);
    };
}

export function getUser(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('users', id).then(user => {
            dispatch(getUserSuccess(user));
        }).catch(error => {
            throw  error;
        });
    }
}

export function detachCompany(userIds) {
    return function (dispatch, getState) {
        return PrivateAPIResource.remove('companies/users', userIds).then(user => {
            // if current user was changed
            if(userIds.indexOf(getState().user.id.toString()) !== -1) {
                dispatch(getCurrentUser());
            }

            toastr.success('Virksomhed ændret sig.');
            dispatch(getUserSuccess(user));
        }).catch(error => {
            throw  error;
        });
    }
}

export function loadUsers(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all(`users?page=${page}`, sortParams).then(users => {
            dispatch(loadUsersSuccess(users));
        }).catch(error => {
            throw  error;
        });
    }
}

/**
 * Add roles to user
 *
 * @param {integer} userId
 * @param {array} roles
 * */
export function addUserRoles(userId, roles) {
    return function (dispatch) {
        return PrivateAPIResource.put(`users/${userId}/add-roles/${roles.join(',')}`).then(() => {
            toastr.success('Tilladelser tilføjet med succes.');
        }).catch(error => {
            throw  error;
        });
    }
}

/**
 * Add roles to user
 *
 * @param {integer} userId
 * @param {array} roles
 * */
export function removeUserRoles(userId, roles) {
    return function (dispatch) {
        return PrivateAPIResource.put(`users/${userId}/remove-roles/${roles.join(',')}`).then(() => {
            toastr.success('Tilladelser fjernet.');
        }).catch(error => {
            throw  error;
        });
    }
}

export function deleteUser(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('users', id).then(() => {
            dispatch(deleteUserSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

// action creators

export function getDemoAdminUser() {
    return function (dispatch) {
        return PrivateAPIResource.get('demo-admin').then(data => {
            if(data.adminUserNotFound) {
                return dispatch(getEmptyDemoAdminUserSuccess());
            }

            dispatch(getDemoAdminUserSuccess(data));
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/userActions.js